import { formatoDuracion } from "./archivos";

/** "Bruno", "Bruno y Carla", "Bruno, Carla y Dana". */
export const enumerar = (nombres) => (
  nombres.length <= 1 ? nombres.join("") : `${nombres.slice(0, -1).join(", ")} y ${nombres[nombres.length - 1]}`
);

const primerNombre = (nombre) => String(nombre || "").split(" ")[0];

/** "📷 Foto", "🎤 Nota de voz (0:12)", "📄 cotización.pdf"... */
export const describirAdjunto = (adjunto) => {
  if (!adjunto) return "";
  if (adjunto.vencido) return "Archivo vencido";
  if (adjunto.categoria === "imagen") return "📷 Foto";
  if (adjunto.categoria === "video") return "🎬 Video";
  if (adjunto.categoria === "audio") {
    if (!/^nota-de-voz/.test(adjunto.nombre || "")) return `🎵 ${adjunto.nombre}`;
    return `🎤 Nota de voz${adjunto.duracion ? ` (${formatoDuracion(adjunto.duracion)})` : ""}`;
  }
  return `📄 ${adjunto.nombre}`;
};

/** El texto de un mensaje en una línea, con lo que trae adjunto. */
export const resumenDeMensaje = (mensaje) => {
  const texto = String(mensaje?.texto || "").replace(/\s+/g, " ").trim();
  return [describirAdjunto(mensaje?.adjunto), texto].filter(Boolean).join(" · ");
};

/** Lo que se lee bajo el nombre en la lista: "Tú: …", "Ana: …" en un grupo, o el texto. */
export const vistaPrevia = (conversacion, usuarioId) => {
  const mensaje = conversacion.ultimoMensaje;
  if (!mensaje) return "Sin mensajes";
  const texto = resumenDeMensaje(mensaje);
  if (mensaje.tipo === "sistema") return texto;
  if (mensaje.usuarioId === usuarioId) return `Tú: ${texto}`;
  return conversacion.tipo === "grupo" ? `${primerNombre(mensaje.autor)}: ${texto}` : texto;
};
